import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api.service';

export interface UserConfig {
  frontegg_id: string;
  current_branch?: string | null;
  dbt_schema_prefix?: string | null;
  has_github_access?: boolean;
  date_dimension_variant?: string | null;
  favorite_node_ids?: string[];
  favorite_analysis_ids?: string[];
  favorite_dashboard_ids?: string[];
  is_internal_staff?: boolean;
  stack?: string;
}

export function useUserConfig() {
  return useQuery<UserConfig>({
    queryKey: ['userConfig'],
    queryFn: async () => {
      const data = await ApiService.getInstance().request('GET', '/user-config');
      return data as UserConfig;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
  });
}
